import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Components
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";

// Pages
import Home from "./pages/Home";
import CPRTraining from "./pages/CPRTraining";
import BlendedCourses from "./pages/BlendedCourses";
import GroupClasses from "./pages/GroupClasses";
import MobileNotary from "./pages/MobileNotary";
import LifeRestCare from "./pages/LifeRestCare";
import BookNow from "./pages/BookNow";
import About from "./pages/About";
import FAQs from "./pages/FAQs";
import Contact from "./pages/Contact";
import BookingJournal from "./pages/BookingJournal";
import NotaryJournal from "./pages/NotaryJournal";
import Shop from "./pages/Shop";
import Events from "./pages/Events";
import VirtualCPR from "./pages/VirtualCPR";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cpr-training" element={<CPRTraining />} />
            <Route path="/blended-courses" element={<BlendedCourses />} />
            <Route path="/group-classes" element={<GroupClasses />} />
            <Route path="/mobile-notary" element={<MobileNotary />} />
            <Route path="/liferest-care" element={<LifeRestCare />} />
            <Route path="/book-now" element={<BookNow />} />
            <Route path="/about" element={<About />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/bookings" element={<BookingJournal />} />
            <Route path="/admin/notary-journal" element={<NotaryJournal />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/events" element={<Events />} />
            <Route path="/virtual-cpr" element={<VirtualCPR />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster 
        position="top-right" 
        richColors 
        closeButton
        toastOptions={{
          style: {
            fontFamily: 'Public Sans, sans-serif',
          },
        }}
      />
    </div>
  );
}

export default App;
